import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const AishDependentLabels: IntakeLabelCollection = {
  livesWithParent: {
    label: 'Does the child live with you?',
    onBehalfLabel: 'Does the child live with <<oboName>>?',
  },
  firstName: {
    label: "Child's first name",
  },
  middleName: {
    label: "Child's middle name",
  },
  lastName: {
    label: "Child's last name",
  },
  firstNameAlt: {
    label: 'First Name',
  },
  middleNameAlt: {
    label: 'Middle Name',
  },
  lastNameAlt: {
    label: 'Last Name',
  },
  birthdate: {
    label: "Child's birthdate",
  },
  birthdateAlt: {
    label: 'Birth Date',
  },
  attendingHighSchool: {
    label: 'Is the child attending high school?',
  },
  attendingHighSchoolAlt: {
    label: 'Is the Dependent attending high school?',
  },
  declarationNote: {
    label:
      'Because you have a child who is 18 or 19 years of age and still in high school you will need to have that child complete and sign this declaration form and upload the document as part of your application.',
    onBehalfLabel:
      'Because <<oboName>> has a child who is 18 or 19 years of age and still in high school, you will need to have that child complete and sign this declaration form and upload the document as part of the application.',
  },
};
